import { observable, action } from 'mobx';
import { inject } from 'aurelia-dependency-injection';
import { UserService } from 'Services/UserService';
import { UserDetailsDto } from 'Api/Features/Users/Dtos/UserDetailsDto';
import { ManagementRoleDto } from 'Api/Features/Users/Dtos/ManagementRoleDto';

@inject(UserService)
class UserStore {
    constructor(private readonly userService: UserService) {}

    @observable
    public callInProgress = false;

    @observable
    public userInfo: UserDetailsDto | null = null;

    @observable
    public userRole: ManagementRoleDto | null = null;

    @action
    async setUserInfo(userId: string): Promise<UserDetailsDto | null> {
        this.callInProgress = true;
        const userInfo = await this.userService.getUser(userId);
        this.userInfo = userInfo;
        this.userRole = userInfo?.managementRoles?.[0]?.name ?? null;
        this.callInProgress = false;
        return userInfo;
    }

    @action
    setCallInProgress(value: boolean): void {
        this.callInProgress = value;
    }

    @action
    clearUserInfo(): void {
        this.userInfo = null;
    }
}

export default UserStore;
